import { createStore, combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'

import user from 'containers/Main/ducks/user'
import gSubscription from 'containers/Main/ducks/subscription';

import clsAdd from './Class/clsAdd'
import clsInfo from './Class/clsInfo'
import clsLst from './Class/clsLst'
import clsStdt from './Class/clsStdt'
import clsStdtSttUpdate from './Class/clsStdtSttUpdate'
import clsSttUpdate from './Class/clsSttUpdate'
import clsTch from './Class/clsTch'
import clsTchUpdate from './Class/clsTchUpdate'
import clsStdtUpdate from './Class/clsStdtUpdate'
import clsJoin from './Class/clsJoin'
import clsCt from './Class/clsCt'
import clsUpdate from './Class/clsUpdate'

import chcStt from './Lesson/chcStt'
import clsLss from './Lesson/clsLss'
import clsLssAdd from './Lesson/clsLssAdd'
import clsLssDelete from './Lesson/clsLssDelete'
import clsLssStdt from './Lesson/clsLssStdt'
import clsLssStdtAdd from './Lesson/clsLssStdtAdd'
import clsLssUpdate from './Lesson/clsLssUpdate'
import stdtChcSttUpdate from './Lesson/stdtChcSttUpdate'
import lssTchUpdate from './Lesson/lssTchUpdate'
import sChcNote from './Lesson/sChcNote'
import tChcNote from './Lesson/tChcNote'
import lsnWithTimeAdd from './Lesson/lsnWithTimeAdd'
import lsnWithTimeUpdate from './Lesson/lsnWithTimeUpdate'
import lsnMultiWithTimeAdd from './Lesson/lsnMultiWithTimeAdd'

import schStdtLst from './School/schStdtLst'
import schTchLst from './School/schTchLst'
import sSignup from './School/sSignup'
import sRegister from './School/sRegister'
import token from './School/token'
import chgPasswd from './School/chgPasswd'
import phVrfction from './School/phVrfction'
import schTradeLst from './School/schTradeLst'
import trEmail from './School/trEmail'
import trNoteGet from './School/trNoteGet'
import trNoteUpdate from './School/trNoteUpdate'
import timetable from './School/timetable'
import sGroupList from './School/sGroupList'
import sPermissionList from './School/sPermissionList'
import groupListRegister from './School/groupListRegister'
import groupListTeacher from './School/groupListTeacher'
import sGroupDetail from './School/sGroupDetail'
import sDeleteGroup from './School/sDeleteGroup'
import sEditGroup from './School/sEditGroup'
import sUpdateGroup from './School/sUpdateGroup'

import rgstStdt from './Student/rgstStdt'
import stdtChcRcd from './Student/stdtChcRcd'
import stdtCrtCls from './Student/stdtCrtCls'
import stdtHstCls from './Student/stdtHstCls'
import stdtInfo from './Student/stdtInfo'
import stdtAttr from './Student/stdtAttr'
import stdtCrdt from './Student/stdtCrdt'
import stdtInfoUpdate from './Student/stdtInfoUpdate'
import stdtLog from './Student/stdtLog'
import stdtSmr from './Student/stdtSmr'
import stdtSmrCt from './Student/stdtSmrCt'
import stdtGetTrade from './Student/stdtGetTrade'
import stdtTrade from './Student/stdtTrade'
import stdtTrade2 from './Student/stdtTrade2'
import stdtHstTrade from './Student/stdtHstTrade'
import schStdtStt from './Student/schStdtStt'
import multiStuArchive from './Student/multiStuArchive'

import rgstTch from './Teacher/rgstTch'
import tchInfo from './Teacher/tchInfo'
import tchStt from './Teacher/tchStt'
import tchUpdate from './Teacher/tchUpdate'
import tLogin from './Teacher/tLogin'
import tchChcRcd from './Teacher/tchChcRcd'

import clsroomDetail from './Classroom/clsroomDetail'
import clsroomLst from './Classroom/clsroomLst'
import clsroomRgst from './Classroom/clsroomRgst'
import clsroomUpdate from './Classroom/clsroomUpdate'

import addAnn  from './Class/addAnn'
import annLst  from './Class/annLst'
import annOperate  from './Class/annOperate'

import paymentMethod from './School/paymentMethod'
import subscription from './School/subscription'
import teacherConfirmation from './School/teacherConfirmation'
import sDeleteSchool from './School/sDeleteSchool'

import gSchoolCurrentTeacher from './Teacher/gSchoolCurrentTeacher'
import gSchoolArchivedTeacher from './Teacher/gSchoolArchivedTeacher'
import inviteTeacher from './Teacher/inviteTeacher'
import gTeacherExit from './Teacher/gTeacherExit'
import getAttendance from 'containers/pages/Teacher/Attendance/ducks'

import Locale from 'ducks/Locale';
import Dev from 'ducks/Dev';
import schMonthlyFinance from './School/schMonthlyFinance';
import teacherList from 'containers/pages/Teacher/ducks';
import classList from 'containers/pages/Class/ducks';
import classroomList from 'containers/pages/Classroom/ducks';
import schedule from 'containers/pages/Schedule/ducks';

import financeTable from 'containers/tables/FinanceTable/ducks';

import classLessonDetail from 'containers/pages/ClassDetail/ducks';
import classStudentDetail from 'containers/pages/ClassDetail/StudentTable/ducks';
import classTeacherDetail from 'containers/pages/ClassDetail/TeacherTable/ducks';
import lessonAttendanceDetail from 'template/Modals/Attendance/ducks';

import posterList from 'containers/pages/Poster/ducks';
import posterDetail from 'containers/pages/Poster/EditPoster/ducks';
import attendeeList from 'containers/pages/Poster/RegistrationTable/ducks';

import clientList from 'containers/pages/PotentialClient/ducks';

// announcement
import announcementList from 'containers/pages/Announcement/redux/reducer'

import 'containers/pages/Student/hotline';

import { getReducers } from 'vendor/react-redux-hotline';

import timelineReducer from 'template/Docks/StudentInfo/Timeline/redux/reducer'

import teacherInfo from 'template/Docks/TeacherInfo/redux/reducer'
import contactInfo from 'template/Docks/ContactInfo/redux/reducer'
import contactNotes from 'template/Docks/ContactInfo/ContactNotes/redux/reducer'
import mediaCenter from 'template/Modals/MediaCenter/redux/reducer'
import schoolStatistic from 'containers/pages/Dashboard/ducks';

//
// REFECTOR REQUIRED
// this should not reside in header
//
import schoolDetail from 'containers/Main/ducks/school-detail';
import schoolLog from 'containers/pages/Logs/ducks';
//
// REFECTOR REQUIRED
//

const reducers = combineReducers({
  routing: routerReducer,

  user,


  clsAdd,
  clsInfo,
  clsLst,
  clsStdt,
  clsStdtSttUpdate,
  clsSttUpdate,
  clsTch,
  clsTchUpdate,
  clsStdtUpdate,
  chcStt,
  clsLss,
  clsLssAdd,
  clsLssDelete,
  clsLssStdt,
  clsLssStdtAdd,
  clsLssUpdate,
  clsJoin,
  clsCt,
  clsUpdate,
  stdtChcSttUpdate,
  lssTchUpdate,
  sChcNote,
  tChcNote,
  lsnWithTimeAdd,
  lsnWithTimeUpdate,
  lsnMultiWithTimeAdd,
  schStdtLst,
  schTchLst,
  sSignup,
  sRegister,
  token,
  chgPasswd,
  phVrfction,
  schTradeLst,
  trEmail,
  trNoteGet,
  trNoteUpdate,
  timetable,
  rgstStdt,
  stdtChcRcd,
  stdtCrtCls,
  stdtHstCls,
  stdtInfo,
  stdtAttr,
  stdtCrdt,
  stdtInfoUpdate,
  stdtLog,
  stdtSmr,
  stdtSmrCt,
  stdtGetTrade,
  stdtTrade,
  stdtTrade2,
  stdtHstTrade,
  schStdtStt,
  rgstTch,
  tchInfo,
  tchStt,
  tchUpdate,
  tLogin,
  tchChcRcd,
  clsroomLst,
  clsroomUpdate,
  clsroomRgst,
  clsroomDetail,
  addAnn,
  annLst,
  annOperate,
  sGroupList,
  sPermissionList,
  groupListRegister,
  groupListTeacher,
  sGroupDetail,
  sDeleteGroup,
  sEditGroup,
  sUpdateGroup,
  paymentMethod,
  subscription,
  gSubscription,
  teacherConfirmation,
  gSchoolCurrentTeacher,
  gSchoolArchivedTeacher,
  inviteTeacher,
  sDeleteSchool,
	gTeacherExit,
  multiStuArchive,
	Locale,
  Dev,
  schMonthlyFinance,
  teacherList,
  classList,
  classroomList,
  schedule,
  financeTable,
  classLessonDetail,
  classStudentDetail,
  lessonAttendanceDetail,
  posterList,
  posterDetail,
  attendeeList,
  getAttendance,
  classTeacherDetail,
  clientList,
  announcementList,
  timelineReducer,
  schoolDetail,
  teacherInfo,
  contactInfo,
  contactNotes,
  mediaCenter,
  schoolLog,
  schoolStatistic,
  ...getReducers(),
});

export default reducers



// WEBPACK FOOTER //
// ./src/reducers/index.js